export const getBulletinFormValues = (bulletin) => ({
  AlertType: bulletin.AlertType || '',
  Flags: bulletin.Flags || null,
  AgencyID: bulletin.AgencyID || '',
  Priority: bulletin.Priority || '1',
  Beginning: bulletin.Beginning || null,
  Ending: bulletin.Ending || null,
  RangeOfEffectiveness: bulletin.RangeOfEffectiveness || '',
  ptsPersonID: bulletin.ptsPersonID || null,
  ptsAddressID: bulletin.ptsAddressID || null,
  ptsVehicleID: bulletin.ptsVehicleID || null,
  Plate: bulletin.Plate || '',
  PlateState: bulletin.PlateState || '',
  OLN: bulletin.OLN || '',
  OLNState: bulletin.OLNState || '',
  Notification: bulletin.Notification || '',
});
